// Material Dashboard 2 React layouts
import Dashboard from "layouts/dashboard";
import SignIn from "layouts/authentication/sign-in";
import Slider from "./views/Slider"
import ServiceType from './views/Service/serviceType.jsx'
import Services from './views/Service/services.jsx';
import Category from './views/Category/category.jsx';
import SubCategory from './views/Category/subCategory';
import OrderStatus from './views/Order/orderStatuses';
import Order from './views/Order/order';
import SosRequests from './views/Order/SosRequests';
import FormListing from './views/Settings/Forms/formListing';
import CreateForm from './views/Settings/Forms/createForm';
import AgreementTemplate from './views/Settings/AgreementTemplate';
import DriverManagement from './views/Drivers/driver';
import Payout from "views/Payout/payout";
import DriverSettlement from "views/DriverSettlement/DriverSettlement";
import DriverDetail from './views/Drivers/driverDetail';
import VehicleManagement from './views/Drivers/vehicles';
import Bank from './views/bank/bank';
import ServiceArea from './views/Service-area/Service-area';
import PrivacyPolicy from './views/Pages/PrivacyPolicy';
import Tutorial from './views/Settings/tutorial';
import News from './views/Pages/news';
import TermCondition from './views/Pages/TermCondition';
import AboutUs from './views/Pages/AboutUs';
import Faqs from './views/Pages/Faqs';
import BoardingScreen from './views/Settings/boardingScreen';
import NotificationManagement from './views/Settings/notification';
import Admin from './views/Admin/Admin';
import Bullet from './views/Bullet/Bullet.jsx';
import Customers from './views/Customers/customers.jsx';
import CustomerDetail from './views/Customers/customerDetail.jsx';
// import Business from './views/Business/business.jsx';
// import BusinessDetail from './views/Business/businessDetail.jsx';
import Partner from './views/Partner/partner.jsx';
import PartnerDetail from './views/Partner/partnerDetails.jsx';
import LivePartners from "./views/Partner/LivePartners.jsx";
import Cancel from './views/Cancel/cancel.jsx';

// @mui icons
import Icon from "@mui/material/Icon";

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
    isPrivate: true,
  },
  {
    type: "collapse",
    name: "Customers",
    key: "customers",
    // icon: <Icon fontSize="small">group</Icon>,
    route: "/dashboard/customers/list",
    component: <Customers />,
    isPrivate: true,
  },
  {
    type: "collapse",
    name: "Customer Detail",
    key: "customer-detail",
    route: "/dashboard/customers/details/:id?",
    component: <CustomerDetail />,
    isPrivate: true,
  },
  {
    type: "collapse",
    name: "Slider",
    key: "slider",
    icon: <Icon fontSize="small">Slider</Icon>,
    route: "/dashboard/slider",
    component: <Slider />,
    isPrivate: true,
  },
  {
    type: "collapse",
    name: "Service Type",
    key: "service-type",
    // icon: <Icon fontSize="small">Ser</Icon>,
    route: "/dashboard/services/service-type",
    component: <ServiceType />,
    isPrivate: true,
  },
  {
    type: "collapse",
    name: "Services",
    key: "services",
    // icon: <Icon fontSize="small">Ser</Icon>,
    route: "/dashboard/services/list",
    component: <Services />,
    isPrivate: true,
  },
  {
    type: "collapse",
    name: "Categories",
    key: "categories",
    // icon: <Icon fontSize="small">Ser</Icon>,
    route: "/dashboard/categories/list",
    component: <Category />,
    isPrivate: true,
  },
  {
    type: "collapse",
    name: "Sub Categories",
    key: "sub-categories",
    // icon: <Icon fontSize="small">Ser</Icon>,
    route: "/dashboard/categories/sub-categories",
    component: <SubCategory />,
    isPrivate: true,
  },

  {
    type: "collapse",
    name: "Orders",
    key: "orders",
    // icon: <Icon fontSize="small">Ser</Icon>,
    route: "/dashboard/orders/list",
    component: <Order />,
    isPrivate: true,
  },
  {
    type: "collapse",
    name: "SOS Requests",
    key: "sos-requests",
    route: "/dashboard/orders/sos-requests",
    component: <SosRequests />,
    isPrivate: true,
  },
  {
    type: "collapse",
    name: "Order Statuses",
    key: "order-statuses",
    // icon: <Icon fontSize="small">Ser</Icon>,
    route: "/dashboard/orders/order-statuses",
    component: <OrderStatus />,
    isPrivate: true,
  },
  // {
  //   type: "collapse",
  //   name: "Drivers",
  //   key: "drivers",
  //   // icon: <Icon fontSize="small">Ser</Icon>,
  //   route: "/dashboard/drivers/list",
  //   component: <DriverManagement />,
  //   isPrivate: true,
  // },
  {
    type: "collapse",
    name: "Payout",
    key: "Payout",
    // icon: <Icon fontSize="small">Ser</Icon>,
    route: "/dashboard/payout/list",
    component: <Payout />,
    isPrivate: true,
  },
  // {
  //   type: "collapse",
  //   name: "Business",
  //   key: "business",
  //   // icon: <Icon fontSize="small">Ser</Icon>,
  //   route: "/dashboard/business/list",
  //   component: <Business />,
  //   isPrivate: true,
  // },
  {
    type: "collapse",
    name: "Partner",
    key: "partner",
    // icon: <Icon fontSize="small">Ser</Icon>,
    route: "/dashboard/partner/list",
    component: <Partner />,
    isPrivate: true,
  },
  {
    type: "collapse",
    name: "Live Partner",
    key: "live-partner",
    route: "/dashboard/partner/live",
    component: <LivePartners />,
    isPrivate: true,
  },
  {
    type: "collapse",
    name: "Cancel",
    key: "cancel",
    route: "/dashboard/cancel/list",
    component: <Cancel />,
    isPrivate: true,
  },
  // {
  //   type: "collapse",
  //   name: "Business Detail",
  //   key: "business-detail",
  //   // icon: <Icon fontSize="small">Ser</Icon>,
  //   route: "/dashboard/business/details/:id?",
  //   component: <BusinessDetail />,
  //   isPrivate: true,
  // },
  {
    type: "collapse",
    name: "Partner Detail",
    key: "partner-detail",
    // icon: <Icon fontSize="small">Ser</Icon>,
    route: "/dashboard/partner/details/:id?",
    component: <PartnerDetail />,
    isPrivate: true,
  },
  {
    type: "collapse",
    name: "Driver Settlement",
    key: "Driver-Settlement",
    // icon: <Icon fontSize="small">Ser</Icon>,
    route: "/dashboard/driverSettlement/list",
    component: <DriverSettlement />,
    isPrivate: true,
  },
  {
    type: "collapse",
    name: "Vehicles",
    key: "vehicles",
    // icon: <Icon fontSize="small">Ser</Icon>,
    route: "/dashboard/drivers/vehicles",
    component: <VehicleManagement />,
    isPrivate: true,
  },
  {
    type: "collapse",
    name: "Drivers",
    key: "drivers",
    // icon: <Icon fontSize="small">Ser</Icon>,
    route: "/dashboard/drivers/details/:id?",
    component: <DriverDetail />,
    isPrivate: true,
  },
  // {
  //   type: "collapse",
  //   name: "Custom Form",
  //   key: "custom-form",
  //   // icon: <Icon fontSize="small">Ser</Icon>,
  //   route: "/dashboard/settings/custom-form",
  //   component: <FormListing />,
  //   isPrivate: true,
  // },
  {
    type: "collapse",
    name: "Bank",
    key: "bank",
    // icon: <Icon fontSize="small">Ser</Icon>,
    route: "/dashboard/bank/list",
    component: <Bank />,
    isPrivate: true,
  },
  {
    type: "collapse",
    name: "Service Area",
    key: "service-area",
    // icon: <Icon fontSize="small">Ser</Icon>,
    route: "/dashboard/service-area/list",
    component: <ServiceArea />,
    isPrivate: true,
  },
  {
    type: "collapse",
    name: "Create Form",
    key: "create-form",
    // icon: <Icon fontSize="small">Ser</Icon>,
    route: "/dashboard/settings/create-form",
    component: <CreateForm />,
    isPrivate: true,
  },
  {
    type: "collapse",
    name: "Create Form",
    key: "create-form",
    // icon: <Icon fontSize="small">Ser</Icon>,
    route: "/dashboard/settings/update-form/:id?",
    component: <CreateForm />,
    isPrivate: true,
  },
  {
    type: "collapse",
    name: "Boarding Screen",
    key: "boarding-screen",
    // icon: <Icon fontSize="small">Ser</Icon>,
    route: "/dashboard/settings/boarding-screen",
    component: <BoardingScreen />,
    isPrivate: true,
  },
  {
    type: "collapse",
    name: "Tutorials",
    key: "tutorial",
    // icon: <Icon fontSize="small">Ser</Icon>,
    route: "/dashboard/settings/tutorial",
    component: <Tutorial />,
    isPrivate: true,
  },
  {
    type: "collapse",
    name: "Notification",
    key: "notification",
    // icon: <Icon fontSize="small">Ser</Icon>,
    route: "/dashboard/settings/notification",
    component: <NotificationManagement />,
    isPrivate: true,
  },
  {
    type: "collapse",
    name: "Agreement Template",
    key: "agreement-template",
    route: "/dashboard/settings/agreement-template",
    component: <AgreementTemplate />,
    isPrivate: true,
  },
  {
    type: "collapse",
    name: "Admin",
    key: "Admin",
    // icon: <Icon fontSize="small">Ser</Icon>,
    route: "/dashboard/Admin/list",
    component: <Admin />,
    isPrivate: true,
  },
  {
    name: "Bullet",
    key: "Bullet",
    route: "/dashboard/Bullet/list",
    component: <Bullet />,
    isPrivate: true,

  },
  {
    type: "collapse",
    name: "Privacy Policy",
    key: "privacy-policy",
    // icon: <Icon fontSize="small">Ser</Icon>,
    route: "/dashboard/pages/privacy-policy",
    component: <PrivacyPolicy />,
    isPrivate: true,
  },
  {
    type: "collapse",
    name: "Terms & Conditions",
    key: "terms-conditions",
    // icon: <Icon fontSize="small">Ser</Icon>,
    route: "/dashboard/pages/terms-conditions",
    component: <TermCondition />,
    isPrivate: true,
  },
  {
    type: "collapse",
    name: "About Us",
    key: "about-us",
    // icon: <Icon fontSize="small">Ser</Icon>,
    route: "/dashboard/pages/about-us",
    component: <AboutUs />,
    isPrivate: true,
  },
  {
    type: "collapse",
    name: "News",
    key: "news",
    // icon: <Icon fontSize="small">Ser</Icon>,
    route: "/dashboard/pages/news",
    component: <News />,
    isPrivate: true,
  },
  {
    type: "collapse",
    name: "Faqs",
    key: "faqs",
    // icon: <Icon fontSize="small">Ser</Icon>,
    route: "/dashboard/pages/faqs",
    component: <Faqs />,
    isPrivate: true,
  },
  {
    type: "collapse",
    name: "Sign In",
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/sign-in",
    component: <SignIn />,
  },

];

export default routes;
